module.exports = __webpack_public_path__ + "static/media/alert.78bf9929.svg";